import { jsx as _jsx } from "react/jsx-runtime";
import Loading, { LoadingBall } from '@ingka/loading';
export default ({ size = 'large', color = 'emphasised', text = '' }) => {
    return (_jsx(Loading, { text: text, children: _jsx(LoadingBall, { size: size, color: color }) }));
};
//# sourceMappingURL=SkapaLoading.js.map